import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import CapturistaDashboard from './components/CapturistaDashboard';
import AsistenciaDashboard from './components/AsistenciaDashboard';
import Navbar from './components/Navbar';

const PrivateRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Rol asistencia solo puede acceder a su propio módulo
  if (user.role === 'asistencia' && requiredRole !== 'asistencia') {
    return <Navigate to="/asistencia" />;
  }

  if (requiredRole && user.role !== requiredRole && user.role !== 'admin') {
    return <Navigate to="/" />;
  }

  return children;
};

const AppRoutes = () => {
  const { isAuthenticated, user } = useAuth();

  return (
    <>
      {isAuthenticated && user?.role !== 'asistencia' && <Navbar />}
      <Routes>
        <Route 
          path="/login" 
          element={!isAuthenticated ? <Login /> : <Navigate to="/" />} 
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              {user?.role === 'admin' ? <AdminDashboard />
                : user?.role === 'asistencia' ? <AsistenciaDashboard />
                : <CapturistaDashboard />}
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute requiredRole="admin">
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/captura"
          element={
            <PrivateRoute>
              <CapturistaDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/asistencia"
          element={
            <PrivateRoute requiredRole="asistencia">
              <AsistenciaDashboard />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
